export default __webpack_public_path__ + "static/media/hourglass.877ca0d7.svg";